import { DOCUMENT } from '@angular/common';
import { Directive, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';

import { watchBodyDarkMode$ } from './echarts-remap-colors';

echarts.use([SVGRenderer]);

@Directive()
export abstract class BaseEchartsDirective {
  protected readonly document = inject(DOCUMENT);
  protected readonly isDark = toSignal(watchBodyDarkMode$(this.document), { initialValue: false });

  readonly initOpts = { renderer: 'svg' } as const;
}
